var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "list-wrapper",
      class: { "list-interaction": _vm.interaction },
    },
    [
      _c(
        "ul",
        { staticClass: "scrollable" },
        _vm._l(_vm.gridData, function (entry, index) {
          return _c(
            "li",
            { key: index, class: { disabled: _vm.disable(entry) } },
            [
              _vm._l(_vm.columns, function (key) {
                return _c("div", { key: key, class: key }, [
                  key === "pages"
                    ? _c(
                        "div",
                        { staticClass: "img-column" },
                        [
                          _vm.name !== "pages"
                            ? _c("page-image-avatar", {
                                attrs: { page: entry.page },
                              })
                            : _c("page-image-avatar", {
                                attrs: { page: entry },
                              }),
                        ],
                        1
                      )
                    : _c("p", { staticClass: "txt" }, [
                        _vm._v(_vm._s(entry.name)),
                      ]),
                ])
              }),
              _c("div", { staticClass: "btn-wrapper" }, [
                _c(
                  "div",
                  [
                    _vm.interaction === true && _vm.getUserPlan
                      ? _c(
                          "vs-button",
                          {
                            staticClass: "add-btn btn-img",
                            attrs: { color: "#2F1937", "vs-type": "filled" },
                            on: {
                              click: function ($event) {
                                return _vm.post(entry.id)
                              },
                            },
                          },
                          [
                            _c("p", [
                              _vm._v(_vm._s(_vm.$t("dash.button.post"))),
                            ]),
                            _c("img", {
                              attrs: {
                                src: require("../../assets/img/icon_more.svg"),
                                alt: "search",
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "vs-button",
                      {
                        attrs: { color: "#a9a9a9", "vs-type": "border" },
                        on: {
                          click: function ($event) {
                            return _vm.edit(entry.id)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("dash.button.edit")))]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            2
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }